import type { ReactNode } from "react";
import type { GridProps } from "@mui/material";
import { Typography, Stack, Checkbox, Grid } from "@mui/material";
import type { CommuneAssocieeDeleguee } from "models";

interface RecapitulatifDeselectionnableCadProps extends GridProps {
  cads?: Array<Partial<CommuneAssocieeDeleguee>>;
  onCommuneChange: (communes: Array<CommuneAssocieeDeleguee>) => void;
}

export function RecapitulatifDeselectionnableCad({
  cads,
  onCommuneChange: onChange,
  ...gridProps
}: Readonly<RecapitulatifDeselectionnableCadProps>): ReactNode {
  if (cads == null || cads.length === 0) return null;

  return (
    <Grid container size={12} spacing={2} {...gridProps}>
      <Typography component={Grid} size={12}>
        Récapitulatif des communes associées/déléguées sélectionnées :
        <br />
        <Typography component="span" variant="caption" color="text.secondary">
          Cliquez sur une commune associée/déléguée pour la retirer de la sélection
        </Typography>
      </Typography>

      <Stack spacing={0}>
        {cads?.map((c) => (
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            key={c.id}
            onClick={() => {
              onChange(
                ((cads ?? []) as Array<CommuneAssocieeDeleguee>).filter((com) => com.id !== c.id)
              );
            }}
            sx={{ cursor: "pointer" }}>
            <Checkbox checked size="small" sx={{ p: 0.5 }} />
            <Typography>
              {c.libelle} <span className="grey">({c.id?.substring(0, 2)})</span>
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Grid>
  );
}
